'use client';
import React from 'react';

import SearchbarHeader from '@domain/carRental/searchBar/home/carRentalMobileHeader';
import { Container } from '@shared';
import CarRentalListResults from '@domain/carRental/results';
import CarRentalListFilters from '@domain/carRental/filters';
import CarRentalHomeSearchBar from '@domain/carRental/searchBar';
import { VehicleListViewModel } from '@api/models/VehicleListViewModel';
import NotFound from '@components/Errors/404/404';
import { useBreakpoint } from '@contexts/breakpoints';

import {
  FilterAndResultContainer,
  PageWrapper,
  SearchBarListContainer,
} from './styled';

export interface CarRentalListPageProps {
  is404?: boolean;
  initialCarRentalSSRData?: VehicleListViewModel;
}

const CarRentalListPage = ({
  is404 = false,
  initialCarRentalSSRData,
}: CarRentalListPageProps) => {
  const { xl } = useBreakpoint();

  return (
    <PageWrapper>
      {xl ? (
        <>
          <SearchBarListContainer>
            <CarRentalHomeSearchBar page='list' />
          </SearchBarListContainer>
        </>
      ) : (
        <SearchbarHeader />
      )}

      <Container className='carRentalList__container'>
        {!initialCarRentalSSRData ? (
          <NotFound
            label='Aradığınız kriterlere uygun araç bulunamadı. Lütfen tekrar deneyiniz.'
            iconSize={124}
            className='carRentalList__notFound'
          />
        ) : (
          <FilterAndResultContainer>
            {initialCarRentalSSRData?.filters ? (
              <CarRentalListFilters filters={initialCarRentalSSRData.filters} />
            ) : null}

            <CarRentalListResults
              initialCarRentalSSRData={initialCarRentalSSRData}
              is404={is404}
            />
          </FilterAndResultContainer>
        )}
      </Container>
    </PageWrapper>
  );
};

export default CarRentalListPage;
